export default __webpack_public_path__ + "static/media/rd2_p2.5b6518ec.png";